import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { queryGSAiHelper } from "../utility/service/aihelper-service";
import { useTranslation } from "react-i18next";
import { checkDpSuccess } from "../utility/service/tool-service";
// import { useSafeKeyDown } from "../utility/hook/useSafeKeyDown";
import { SimpleRefInput } from "./SimpleInput";
import SafeMarkdownRenderer from "./SafeMarkdownRenderer";
import { PulseLoader } from "react-spinners";

const LexiDialogLoadingBox = () => {
    return (
      <div className="lexi">
        <div className="loading-lexi-box">
          <div>
            <PulseLoader color="var(--gray-300)" size={12} margin={4} />
          </div>
        </div>
      </div>
    );
}
const LexiDialogBox = ({ content, time = new Date().toLocaleTimeString() }) => {
    return (
        <div className="lexi">
            <div className="lexi-box">
                <SafeMarkdownRenderer content={content} />
            </div>
            <span className="time-sign">{time}</span>
        </div>
    )
}
const UserDialogBox = ({ content, time = new Date().toLocaleTimeString() }) => {
    return (
        <div className="user">
            <div className="user-box">
                <SafeMarkdownRenderer content={content} />
            </div>
            <span className="time-sign">{time}</span>
        </div>

    )
}
const HelperBox = ({ helloString, hoverString }) => {    
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showHello, setShowHello] = useState(true);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        if (currentIndex >= helloString.length) {
            setShowHello(false);
            return;
        }
        const timer = setTimeout(() => {
            setCurrentIndex(prev => prev + 1);
        }, 3000);

        return () => clearTimeout(timer);

    }, [currentIndex, helloString?.length])

    if (!isVisible) return null;


    return (
        <>
        <div
          className="helper-greeting-box"
          style={{ display: showHello ? 'block' : 'none'}}
          onClick={() => setIsVisible(false)}
        >
          <span dangerouslySetInnerHTML={{ __html: helloString?.[currentIndex] }} />
        </div>
      
        <div
          className={`${hoverString?.length>0?'helper-hover-box':''} `}
          style={{ display: showHello ? 'none' : 'block'}}
        >
          <span dangerouslySetInnerHTML={{ __html: hoverString }} />
        </div>
      </>
    )
}
const AiLexiHelper = ({ helperMsgList = [], helperPopupList=[], helperTipsList=[] }) => {

    const { t } = useTranslation();
    const [openHelper, setOpenHelper] = useState(false);
    const [aiProblemList, setAiProblemList] = useState([]);//fake
    const inputRef = useRef();
    const bottomRef = useRef();
    const [isLoading, setIsLoading] = useState(false);
    const iframeSrc = `${process.env.PUBLIC_URL}/aiHelper/GSAI.html`; //iframe url

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (e?.target?.value) {
                btnSend();
            }
        }
    };

    // const { onKeyDown, onCompositionStart, onCompositionEnd } =
    // useSafeKeyDown(handleKeyDown);

    const btnSend = async () => {
        if (inputRef.current.value) {
            setAiProblemList((pre) => {
                return [...pre,
                {
                    content: inputRef.current.value,
                    role: 'User',
                    time: new Date().toLocaleTimeString()
                }]
            })
            setTimeout(() => {
                inputRef.current.value = ""; //打完後清空項目
            }, 200);
            setIsLoading(true)
            queryGSAiHelper({ query: inputRef.current.value })
                .then((res) => {
                    if (checkDpSuccess(res)) {
                        let data = res?.data?.RespBody?.response;
                        setAiProblemList((pre) => {
                            return [...pre,
                            {
                                content: data,
                                role: 'Lexi',
                                time: new Date().toLocaleTimeString()
                            }]
                        })
                    }


                }).catch(err => {
                    console.log(err);


                }).finally(fin => {
                    setIsLoading(false);
                })
        } else {
            inputRef?.current?.focus();
        }

    }

    const scrollToBottom = () => {
        bottomRef?.current?.scrollIntoView({ behavior: "smooth" });
        inputRef?.current?.focus();
    };

    useEffect(() => {
        scrollToBottom();
    }, [aiProblemList]);

    useEffect(()=>{
        if(aiProblemList?.length ===0){
            setAiProblemList(pre => [
                ...pre,
                ...helperPopupList.map(data => ({
                    content: data,
                    role: 'Lexi',
                    time: new Date().toLocaleTimeString()
                }))
            ]);

        }
    },[openHelper])


    return (
        <>
            <div className="layout-content-helper" onClick={() => setOpenHelper(!openHelper)}></div>
            <HelperBox helloString={helperMsgList} hoverString={helperTipsList?.join('<br>')} />

            {/* {openHelper && ( */}
            <div style={{ display: openHelper ? '' : 'none' }} className="helper-window">
                <div className="window-header">
                    <h4>{t('gsHelper')}</h4>
                    {/* <Button text rounded 
                            icon="pi pi-times"
                            onClick={() => setOpenHelper(false)}/> */}
                    <button className="window-header-btn"
                        onClick={() => setOpenHelper(false)}>
                        <i className="pi pi-times" ></i>
                    </button>
                </div>
                <div className="window-content">
                    {
                        aiProblemList?.map((item, index) => {
                            switch (item?.role) {
                                case 'Lexi':
                                    return <LexiDialogBox key={`${item.time}_lexi_${index}`} content={item.content} time={item.time} />;
                                case 'User':
                                    return <UserDialogBox key={`${item.time}_User_${index}`} content={item.content} time={item.time} />;
                            }
                        })
                    }
                    {/* <iframe
                        src={iframeSrc}
                        style={{ width: '100%', height: '100%', border: 'none' }}
                    /> */}
                    {isLoading && <LexiDialogLoadingBox />}

                    {/* scroll to bottom mark */}
                    <div ref={bottomRef}></div>
                </div>

                <div className="window-footer">
                    <SimpleRefInput
                        disabled={isLoading}
                        ref={inputRef}
                        handleKeyDown={handleKeyDown}
                        placeholder={t('plz_enter')}
                    />
                    {/* <input 
                            disabled={isLoading} 
                            type="text" ref={inputRef} 
                            onKeyDown={onKeyDown}
                            onCompositionStart={onCompositionStart}
                            onCompositionEnd={onCompositionEnd}
                            /> */}
                    <button className="window-footer-btn" onClick={() => { if (!isLoading) btnSend(); }} disabled={isLoading}>
                        <i className={`pi ${isLoading ? 'pi-spin pi-spinner' : 'pi-send'}`}></i>
                    </button>
                </div>
            </div>
            {/* )} */}
        </>
    )
}

export default AiLexiHelper;